import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, makeStyles, Typography } from "@material-ui/core";
// import { ExpandMoreIcon } from "@material-ui/core/Icon";
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Link } from 'react-router-dom';


let useStyles = makeStyles((theme) => ({
    Accordion: {
        width: "100%",
        padding: "10px",
        textAlign: "center !important",
        boxShadow: "none",
        borderBottom: "1px solid #f2f2f2",
    },
    AccordionSummary: {
        width: "100%",
        textAlign: "center !important",
    },
    titleAccordion: {
        width: "100%",
        textAlign: "center !important",
    },
    AccordionDetails: {
        backgroundColor: "#fafafa",
        display: 'block',
        padding: 0,
    },
    subMenu: {
        width: "100%",
        padding: "8px 0",
    },
    listItem: {
        textAlign: "center !important",
    },
    title: {
        width: "100%",
        padding: "10px 0",
        textAlign: "center !important",
        boxShadow: "none",
        borderBottom: "1px solid #f2f2f2",
    },
    listItemTitle: {
        backgroundColor: "transparent !important",
        textAlign: "center !important",
    }
}));

export default function Index({ data }) {

    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };


    return (
        <div>
            {
                data?.child?.length > 0 && (
                    <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')} className={classes['Accordion']}>
                        <AccordionSummary
                            //   expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            className={classes['AccordionSummary']}

                        >
                            <Typography sx={{ width: '100%', flexShrink: 0, textAlign: 'center' }} className={classes['titleAccordion']}>
                                {data?.label}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails className={`${classes['AccordionDetails']}`}>
                            {
                                data?.child?.map((item, index) => {
                                    if (item?.child?.length > 0) {
                                        return (
                                            <div key={index}>
                                                {
                                                    item.child.map((leafItem, leafIndex) => (
                                                        <div key={leafIndex} className={classes['subMenu']}>
                                                            {
                                                                leafItem.route?.slice(0, 4) === "http"
                                                                    ? <a target="_blank" rel="noopener noreferrer" href={leafItem.route} style={{ display: 'inline-block', padding: 17 }} >
                                                                        {leafItem.label}
                                                                        {
                                                                            leafItem?.badge?.title && (
                                                                                <span className={classes['badge']}>
                                                                                    {leafItem?.badge?.title}
                                                                                </span>
                                                                            )
                                                                        }
                                                                    </a>
                                                                    :
                                                                    <ListItem
                                                                        className={classes.listItem}
                                                                        button
                                                                        component={Link}
                                                                        to={leafItem.route || '#'}
                                                                    >
                                                                        <ListItemText
                                                                            primary={leafItem.label}
                                                                            className={classes.itemText}
                                                                        />
                                                                        <Divider />
                                                                    </ListItem>
                                                            }
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        );
                                    }
                                    if (item?.route) {
                                        return (
                                            <div key={index} className={classes['subMenu']}>
                                                {
                                                    item.route?.slice(0, 4) === "http"
                                                        ? <a target="_blank" rel="noopener noreferrer" href={item.route} style={{ display: 'inline-block', padding: 17 }}>
                                                            {item.label}
                                                            {item?.badge?.title && (
                                                                <span className={classes['badge']}>{item?.badge?.title}</span>
                                                            )}
                                                        </a>
                                                        : <List>
                                                            <ListItem
                                                                className={classes.listItemTitle}
                                                                button
                                                                component={Link}
                                                                to={item.route || '#'}
                                                            >
                                                                <ListItemText
                                                                    primary={item.label}
                                                                    className={classes.itemTextTitle}
                                                                />
                                                                <Divider />
                                                            </ListItem>
                                                        </List>
                                                }
                                            </div>
                                        );
                                    }
                                    return null;
                                })
                            }
                        </AccordionDetails>
                    </Accordion>
                )
            }
            {
                data?.child?.length === 0 && data?.route && (
                    <div className={classes['title']}>
                        {
                            data.route.slice(0, 4) === "http" ?
                                <a target="_blank" rel="noopener noreferrer" href={data.route} style={{ display: 'inline-block', padding: 17 }}>
                                    {data.label}
                                    {
                                        data?.badge?.title && (
                                            <span className={classes['badge']}>
                                                {data?.badge?.title}
                                            </span>
                                        )
                                    }
                                </a>
                                :
                                <List>

                                    <ListItem
                                        className={classes.listItemTitle}
                                        button
                                        component={Link}
                                        to={data?.route}
                                    >
                                        <ListItemText
                                            primary={data.label}
                                            className={classes.itemTextTitle}
                                        />
                                        <Divider />

                                    </ListItem>
                                </List>
                        }

                    </div>
                )
            }

        </div>
    );
}


